import React, { Component } from 'react';
import _ from 'lodash';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux'
import cx from 'classnames';
import InfoIcon from '@material-ui/icons/Info';
import { ExportToCsv } from 'export-to-csv';
// import ReorderIcon from '@material-ui/icons/Reorder';
import DragIndicatorIcon from '@material-ui/icons/DragIndicator';
// import PanToolIcon from '@material-ui/icons/PanTool';
import {
  WithStyles,
  Theme,
  createStyles,
  Grid,
  Typography,
  Button,
  withStyles,
  Menu,
  MenuItem,
  Paper,
  List,
  ListItem,
  LinearProgress,
  ListItemText,
  ListItemIcon
} from '@material-ui/core';

import {
  MoreVert as MoreIcon,
  KeyboardBackspace as BackIcon,
} from '@material-ui/icons';
import { MyPATIconButton, MyPATSelect, MyPATExpansionPanel, MyPATLink, ModalComponent } from '../../common';
import SubjectAddDialogDialog from '../components/contentDialog/subjectAddDialog';
import SubSubjectAddDialog from '../components/contentDialog/subSubjectAddDialog';
import ChaptersAddDialog from '../components/contentDialog/chapterAddDialog';
import ConceptAddDialog from '../components/contentDialog/conceptAddDialog';
import PublishGoalDialog from '../components/contentDialog/publishGoalDialog';
import { getMaster, getCourseData, updateCourseData, setShowAddContent } from '../actions/goalManagementActions';
import GoalManagementService from '../services/goalManagementService';
import { CourseBody } from '../types/CourseBody'
import CourseSyllabusBody from '../types/CourseSyllabusBody';
import ACL from '../../acl/components/ACL';
import ACLService from '../../acl/services/aclService'
import MasterEntityDialog from '../components/MasterEntityDialog';
import LocalEntityDialog from '../components/LocalEntityDialog';
import SyllabusDeleteConfirm from '../components/contentDialog/SyllabusDeleteConfirm'
import { CodeInitials } from '../types/GoalManagementMasterBody';
import ResponseBasedACL from '../../acl/components/ResponseBasedACL';
import AddCircleOutlineIcon from '@material-ui/icons/AddCircleOutline';
import RemoveCircleOutlineIcon from '@material-ui/icons/RemoveCircleOutline';
import { object } from 'prop-types';
import { GOAL_ACTION_TYPE_CONST } from './GoalManagementContainer';
import AddGoalDialog from '../components/AddGoalDialog';
import { toggleLicenseExpiredDialog, setLoggedInUser } from "../../login/actions/userActions";

const styles = (theme: Theme) => createStyles({
  blueColor: {
    color: '#1D7DEA'
  },

  greenBackgroundColor: {
    backgroundColor: "#30BE76 !important",
  },

  borderBlueBtn: {
    color: '#1D7DEA',
    border: 'solid 1px #1D7DEA',
    boxSizing: 'border-box',
    fontSize: '1rem',
    background: '#fff',
    boxShadow: 'none'
  },

  contentContainer: {
    height:60,
    padding: "0 20px",
    // margin: '30px ​0px 16px',
    background: "#FFFFFF",
    boxShadow: "0px 0px 3px rgba(0, 0, 0, 0.287534)",
    lineHeight: "1rem",
    borderRadius:4,
    '& h6': {
      fontWeight: 600,
      fontSize: 20,
      lineHeight: '20px',
      color: '#333333'
    },
  },

  countContentCard: {
    background: '#FAFAFA',
    border: '1px solid #DFDFDF',
    boxSizing: 'border-box',
    boxShadow: '0px -2px 8px rgba(0, 0, 0, 0.16)',
    borderRadius: 4,
    height: 44,
    bottom: 0,
    '& p': {
      fontSize: '0.875rem',
      color: '#999999'
    }
  },

  greyColor: {
    color: '#666666',
  },

  cursorPointer: {
    cursor: 'pointer'
  },

  lightGrey: {
    color: '#333333'
  },

  fontSize16: {
    fontSize: '1rem'
  },

  fontSize20: {
    fontSize: '1.25rem'
  },

  mb2x: {
    marginBottom: 24,
  },

  mb1x: {
    marginBottom: theme.spacing.unit / 4
  },

  root: {
    flexGrow: 1,
    padding: 0,
    '& li': {
      cursor: "pointer",
      padding: 0,
      '&:first-child': {
        paddingRight: 0,
      }
    }
  },

  pageTitle: {
    '& > *': {
      marginRight: theme.spacing.unit,
    },
    '& > svg': {
      fontSize: '2em',
    }
  },

  activeSelected: {
    backgroundColor: "#1D7DEA !important",
    '& *': {
      color: theme.palette.common.white,
    },
    borderRadius: '4px 4px 0px 0px'
  },

  editGoalCardContent: {
    ...theme.mixins.gutters(),
    paddingTop: theme.spacing.unit * 2,
    paddingBottom: theme.spacing.unit * 2,
    position: 'relative',
    '&:last-child': {
      paddingBottom: theme.spacing.unit * 2,
    },
  },

  progressWrapper: {
    display: 'inline-block',
    '& p': {
      lineHeight: 'inherit',
    }
  },

  smallText: {
    position: "absolute",
    bottom: 0,
    right: 10,
    zIndex: 1,
    opacity: 1,
    top: '12px',
    maxWidth: 110,  
  },

  uniqueCodeLabel: {
    position: "absolute",
    bottom: 0,
    right: "30px",
    zIndex: 1,
    opacity: 1,
  },

  pT6: {
    paddingTop: "6px",
  },

  list: {
    '& div:first-child': {
      '& span:first-child': {
        marginBottom: theme.spacing.unit / 2,
      }
    }
  },

  unmappedInfo: {
    padding: '12px',
    borderBottom: "0.5px solid #e0e0e0",
    opacity: 0.54,
  },

  notMapped: {
    background: '#F6DDDD',
    '& .listItemIcon': {
      marginRight: '-3px',
      '& svg': {
        margin: "auto -6px auto 10px",
        fontSize:24,
      }
    }
  },

  subHeader: {
    padding: theme.spacing.unit,
    fontSize: '1.25rem',
    fontWeight: 400,
    borderBottom: "0.5px solid #e0e0e0",
    color: '#333333'
  },

  umMappedHeader: {
    padding: theme.spacing.unit,
    fontSize: theme.spacing.unit * 2,
    fontWeight: 700,
  },

  progressBar: {
    width: 300,
    display: 'inline-block',
    height: theme.spacing.unit / 2,
    backgroundColor: theme.palette.grey[400],
    borderRadius: theme.spacing.unit / 2,
    '& div': {
      backgroundColor: '#72C936',
    }
  },

  gridMinHeight: {
    minHeight: 'calc(100% - 36px)',
  },

  btnAddNewGoal: {
    marginRight: theme.spacing.unit * 2,
    verticalAlign: 'middle',
    display: "inline-flex",
    cursor: "pointer",
  },

  paper: {
    width: "100%",
    height: '100%',
    // '& ul': {
    //   minHeight: 713, May implement it later
    //   height: '100%',
    // },
    color: theme.palette.text.secondary,
  },

  firstPaper: {

  },

  cardMinHeigth: {
    padding: 0,
    height: '100%',
    minHeight: 713,
    '&>:first-child': {
      padding: 0
    }
  },

  moreMenu: {
    'top': "42px",
    '& li': {
      height: theme.spacing.unit * 2,
      color: theme.palette.text.secondary,
      fontSize: '0.8rem',
      paddingTop: theme.spacing.unit,
      paddingBottom: theme.spacing.unit,
      '& > svg': {
        marginRight: theme.spacing.unit,
        fontSize: '1rem',
      }
    }
  },

  listItemLabel: {
    display: 'block',
    padding: '8px 10px 8px 0px',
    overflow: 'hidden',
    whiteSpace: 'nowrap',
    textOverflow: 'ellipsis',
    maxWidth: '150px',
  },
  listItemLabelWithoutEdit: {
    display: 'block',
    padding: '8px 10px 8px 10px',
    overflow: 'hidden',
    whiteSpace: 'nowrap',
    textOverflow: 'ellipsis',
    maxWidth: '200px',
  },
  listItemWrapper: {
    position: 'relative',
    padding: 0,
    display: "block",
    '& .listItemIcon': {
      marginRight: '-3px',
      '& svg': {
        margin: "auto -6px auto 10px",
        fontSize:24,
      }
    }
  },
  conceptPadding: {
    padding: 0,
    '& .listItemIcon': {
      marginRight: '-3px',
      '& svg': {
        margin: "auto -6px auto 10px",
        fontSize:24,
      }
    }
  },

  padding3x: {
    padding: '30px 20px !important'
  },

  padding2x: {
    padding: '0px 12px !important'
  },

  draftBtn: {
    backgroundColor: '#fff',
    color: '#1D7DEA',
    borderRadius: '24px',
    padding: '2px 10px',
    border: 'solid 1px',
    textTransform: 'capitalize',
    fontSize: '0.78rem',
    cursor: 'default'
  },

  published: {
    color: '#1D7DEA',
  },

  draft: {
    color: '#333333'
  },

  expired: {
    color: '#f50057'
  },

  live: {
    color: '#30BE76',
  },

  infoIcon: {
    cursor: 'pointer',
    lineHeight:'16px',
    '& svg': {
      fontSize: 26
    }
  },

  title: {
    maxWidth: 250,
    fontSize:24,
    fontWeight:600,
  },
  marginTop30:{
    marginTop: 30,
  }
});

interface EditGoalManagementContainerProps extends WithStyles<typeof styles> {
  history: any,
  match: any,
  location: any,
  addGoalClickHandler: (id: string, name: string) => void,
  getMaster: (getMasterBy: string, id: string, classId: string, courseId?: string) => void,
  getCourseData: (courseId: string) => void,
  updateCourseData: (courseData: CourseSyllabusBody) => void,
  setShowAddContent: (value: boolean) => void,
  showAddContent: boolean,
  courseData: CourseSyllabusBody[],
  userData: any,
  isPostExpiryDays: any,
  showLicenseExpiredDialog: any,
  toggleLicenseExpiredDialog: any,
  setLoggedInUser: any
}

interface EditGoalManagementContainerState {
  moreMenuAnchor: any,
  subjectAdd: boolean,
  subSubjectAdd: boolean,
  chapterAdd: boolean,
  publishContent: boolean,
  conceptAdd: boolean,
  masterEntity: boolean,
  localEntity: boolean,
  activeCourse: any,
  selectedGoal: {
    selectedSubject: string,
    selectedSubSubject: string,
    selectedChapter: string,
    selectedConcepts: string
  },
  classList: any[],
  courseDataList: any,
  courseList: CourseBody[],
  selectedSubjectDetail: any,
  selectedSubSubjectDetail: any,
  selectedChapter: any,
  mappedPer: number,
  selectedEntity: any,
  showAddContent: boolean,
  deleteDialog: {
    isDeleteDialogOpen: boolean,
    toRemoveId: string[],
    topicName: string,
    topicType: string,
  },
  currentUniqueCode: string,
  orderNo: number,
  goalDialogOpen: boolean,
  dialogData: any,
  actionType: string,
  goalList: any[],
  years: string[],
  showError: boolean
}

class EditGoalManagementContainer extends Component<EditGoalManagementContainerProps, EditGoalManagementContainerState> {
  constructor(props: EditGoalManagementContainerProps) {
    super(props);
    this.state = {
      moreMenuAnchor: null,
      subjectAdd: false,
      subSubjectAdd: false,
      chapterAdd: false,
      conceptAdd: false,
      publishContent: false,
      masterEntity: false,
      localEntity: false,
      selectedGoal: {
        selectedSubject: '',
        selectedSubSubject: '',
        selectedChapter: '',
        selectedConcepts: ''
      },
      classList: [],
      showAddContent: false,
      courseList: [],
      activeCourse: {},
      courseDataList: {
        "class": [],
        "subject": {},
        "sub-subject": {},
        "chapter": {},
        "concept": {}
      },
      selectedSubjectDetail: {},
      selectedSubSubjectDetail: {},
      selectedChapter: {},
      mappedPer: 0,
      selectedEntity: {},
      currentUniqueCode: '',
      orderNo: 1,
      deleteDialog: { isDeleteDialogOpen: false, toRemoveId: [], topicName: '', topicType: '' },
      goalDialogOpen: false,
      dialogData: {},
      actionType: '',
      goalList: [],
      years: [],
      showError: false
    };

    this.handleMoreMenuOpen = this.handleMoreMenuOpen.bind(this);
    this.handleMoreMenuClose = this.handleMoreMenuClose.bind(this);
    this.handleSubjectSelect = this.handleSubjectSelect.bind(this);
    this.handleDoubleClick = this.handleDoubleClick.bind(this);
    this.handleMapToMaster = this.handleMapToMaster.bind(this);
    this.LocalEntityUpdateHandler = this.LocalEntityUpdateHandler.bind(this);
    this.handleViewGoalDialogOpen = this.handleViewGoalDialogOpen.bind(this);
    this.handleViewGoalDialogClose = this.handleViewGoalDialogClose.bind(this);
    this.onSequenceNumberEdit = this.onSequenceNumberEdit.bind(this);

  }
  buttonPressTimer: any;//for longpress

  componentDidMount() {
    this.initi();
    this.getYear();
    this.props.setLoggedInUser();
    GoalManagementService.goalList("").then((res:any)=>{
      // this.setState({
      //   goalList:res
      // })
    })
  }

  getYear = () => {
    let { years } = this.state;
    let currentYear = new Date().getFullYear();
    for (let i = currentYear - 5; i <= currentYear + 10; i++) {
      years.push(i.toString());
    }
    this.setState({ years });
  }

  handleViewGoalDialogOpen = (e: any, id: string) => {
    e.stopPropagation();
    let { dialogData, years, activeCourse } = this.state;
    dialogData = activeCourse;
    dialogData["getCurrentYear"] = years;
    this.setState({ goalDialogOpen: true, dialogData, actionType: GOAL_ACTION_TYPE_CONST.READ_ONLY });
  }

  handleViewGoalDialogClose = () => {
    return this.setState({
      goalDialogOpen: false,
      dialogData: {},
      actionType: ''
    });
  }

  onDeleteConfirmed(isDeleted: boolean) {
    let { activeCourse, deleteDialog, courseDataList }: any = this.state;
    let removedId = deleteDialog.toRemoveId;
    deleteDialog = { isDeleteDialogOpen: false, toRemoveId: "" };
    this.setState({ deleteDialog });
    if (isDeleted) {
      this.changeOrdering(removedId.pop());
    }
  }

  changeOrdering(removedId: string) {
    let { deleteDialog, courseList, selectedGoal, activeCourse, courseDataList } = this.state;
    let { courseData } = this.props;
    let reqBody: any[] = [];

    let deletedData: any = _.find(courseData, ['_id', removedId]);
    let deleteClassId = "";
    if (!_.isUndefined(deletedData)) {
      let deleteClassData = courseData.filter((dd: any) => dd.type == "class" && deletedData.ancestors.includes(dd._id));
      deleteClassId = deleteClassData && deleteClassData.length > 0 ? deleteClassData[0]["_id"] : "";
    }


    //Same level
    courseData.forEach((cd: any) => {
      let changeId = "";
      let oldUniqueCode = "";
      let newUniqueCode = "";
      let childDat: any[] = [];
      if (cd.parent == deleteClassId && cd.orderNo > deletedData.orderNo) {
        changeId = cd._id;
        cd.orderNo = --cd.orderNo;
        oldUniqueCode = cd.uniqueCode.replace(CodeInitials[cd.type], '');
        cd.uniqueCode = cd.uniqueCode.substring(0, cd.uniqueCode.length - 2);
        cd.uniqueCode += cd.orderNo < 10 ? `0${cd.orderNo}` : cd.orderNo;
        newUniqueCode = cd.uniqueCode.replace(CodeInitials[cd.type], '');
        childDat = courseData.filter((dd: any) => dd.ancestors.includes(changeId));
        reqBody.push(cd);
      }


      //For ancestors
      if (changeId && childDat.length > 0) {
        childDat.forEach((chd: any) => {
          chd.uniqueCode = chd.uniqueCode.replace(oldUniqueCode, newUniqueCode);
          reqBody.push(chd);
        });
      }
    });

    // GoalManagementService.updateCourse({ data: reqBody })
    //   .then((res) => {
        this.props.getCourseData(activeCourse._id);
      // })


  }

  initi() {
    let { match, history } = this.props;
    let groupId = match.params.id;
    let currentVersionId = window.location.href.substring(window.location.href.lastIndexOf("#") + 1, window.location.href.length);;
    let hash = history.location.hash;

    if (!_.isUndefined(groupId)) {
      GoalManagementService.fetchCourseByGroupId(groupId)
        .then((courseList: any) => {
          //sort by letest year 
          courseList.sort((a: any, b: any) => parseInt(b.targetYear) - parseInt(a.targetYear));
          const activeCourse = courseList && courseList.length > 0 ? courseList.find((course: any) => course._id === currentVersionId) : {};
          this.setState({ courseList, activeCourse, dialogData: activeCourse });
          this.props.getCourseData(activeCourse._id);
          this.props.getMaster('subject', '', '', activeCourse._id);
        });

      //Get master class and subject
      this.props.getMaster('class', '', '')
      //NOTE:This is used under sync and next
      sessionStorage.removeItem('processedParent');
    }
  }

   componentDidUpdate(prevProps: EditGoalManagementContainerProps, prevState: EditGoalManagementContainerState) {
    if (prevProps != this.props) {

      if (this.props.courseData && (this.props.courseData != prevProps.courseData)) {
        const defaultCourseDataList = {
          "class": [],
          "subject": {},
          "sub-subject": {},
          "chapter": {},
          "concept": {}
        };

        let courseDataList = _.cloneDeep(this.state.courseDataList);
        let selectedGoal = _.cloneDeep(this.state.selectedGoal);
        let courseData = _.cloneDeep(this.props.courseData);
        if (_.isArray(courseData) && courseData.length > 0) {
          let ac: any = [];

          courseDataList = defaultCourseDataList;


          courseDataList["class"] = courseData.filter(c => c.type == "class");
          let reqBody: any[] = [];

          courseData.forEach((cD: any, cdI: number) => {

            if (['subject', 'sub-subject', 'chapter', 'concept'].includes(cD.type)) {

              //change in parent id from string to object
              // if (cD.parent && cD.parent.id) {
              //   cD.parent = cD.parent.id
              // }
              if (!courseDataList[cD.type][cD.parent.id]) {
                courseDataList[cD.type][cD.parent.id] = [cD];
                //On Course Data
                _.forEach(courseDataList[cD.type][cD.parent.id], (cCD: any, cCDI: number) => {
                  //if order no not matching and not having
                  if (!cCD.orderNo || courseDataList[cD.type][cD.parent.id][cCDI].orderNo != cCDI + 1) {
                    courseDataList[cD.type][cD.parent.id][cCDI].orderNo = cCDI + 1;  // orderno generating
                  }

                  if(cCD.sequenceNumber === '' && cCD.type !== 'subject') {
                    let parentData: any = _.cloneDeep(courseData.find((cd: any) => (cd._id == cCD.parent.id)));
                    let order = _.get(cCD, 'orderNo', 1)
                    order = (order < 10) ? '0' + order.toString() : order.toString();
                    cD.sequenceNumber = (parentData && parentData.sequenceNumber) + order;
                    reqBody.push(cCD);
                  }
                  ac = [];
                  //Current Class id finding
                  let currClass = courseDataList['class'].find((el: any) => el.id === cCD.parent && cCD.parent.id);
                  if (currClass && !_.isUndefined(currClass._id)) {
                    ac.push(currClass._id);
                  }
                  if (cCD.type !== 'subject') {
                    ac.push(cCD.parent)
                  }
                  const uniqueCodeData: any = cCD.type == 'subject' ? [{ orderNo: currClass ? currClass.name : '' }] : ac;

                  //Generating UniqueCode
                  let uniqueCode: any = GoalManagementService.generateUniqueCode((cCD.type == 'subject' ? [] : courseData), uniqueCodeData, cCDI + 1, cD.type); //unique code generation

                  if (!cCD.uniqueCode || cCD.uniqueCode != uniqueCode) //checking uniqueCode having or mismatch
                  {
                    courseDataList[cD.type][cD.parent.id][cCDI].uniqueCode = uniqueCode; //updating uniqueCode
                  }
                })
              }

              else {

                courseDataList[cD.type][cD.parent.id].push(cD);

                //On Course Data

                _.forEach(courseDataList[cD.type][cD.parent.id], (cCD: any, cCDI: number) => {
                  if (!cCD.orderNo || courseDataList[cD.type][cD.parent.id][cCDI].orderNo != cCDI + 1) {
                    courseDataList[cD.type][cD.parent.id][cCDI].orderNo = cCDI + 1;
                  }

                  let ancestors = []


                  ac = []

                  let currClass = courseDataList['class'].find((el: any) => el._id === (cCD.parent && cCD.parent.id)); // current class

                  if (currClass && !_.isUndefined(currClass._id)) {
                    ac.push(currClass._id);
                  }

                  if (cCD.type !== 'subject') {
                    ac.push(cCD.parent)
                  }
                  if(cCD.sequenceNumber === '' && cCD.type !== 'subject') {
                    let parentData: any = _.cloneDeep(courseData.find((cd: any) => (cd._id == cCD.parent.id)));
                    let order = _.get(cCD, 'orderNo', 1)
                    order = (order < 10) ? '0' + order.toString() : order.toString();
                    cD.sequenceNumber = (parentData && parentData.sequenceNumber) + order;
                    reqBody.push(cCD);
                  }
                  const uniqueCodeData: any = cCD.type == 'subject' ? [{ orderNo: currClass ? currClass.name : '' }] : ac;

                  let uniqueCode: any = GoalManagementService.generateUniqueCode((cCD.type == 'subject' ? [] : courseData), uniqueCodeData, cCDI + 1, cD.type); //unique code generation

                  if (!cCD.uniqueCode || cCD.uniqueCode != uniqueCode) //checking uniqueCode having or mismatch
                  {
                    courseDataList[cD.type][cD.parent.id][cCDI].uniqueCode = uniqueCode; //updating uniqueCode
                  }
                })

              }


            }

          });
          if(!_.isEmpty(courseDataList.subject) ){
            let id = courseDataList.class[0]._id
            if(!(courseDataList.subject[id] && courseDataList.subject[id][0].sequenceNumber)) {
              this.generateSequenceNumberForData(courseDataList)
            }
          }

          if(reqBody && reqBody.length > 0) {
            GoalManagementService.updateCourse({ data: reqBody })
             .then((res) => {
               setTimeout(() => {
                 this.props.getCourseData(this.state.activeCourse._id);
               }, 500);
             });
           }

          //NOTE:This will help to select list on page load
          if (_.isEmpty(selectedGoal.selectedSubject)) {
            let classId = "";
            let subjectId = "";
            let subSubjectId = "";
            let chapterId = "";
            if (courseDataList["class"].length > 0) {
              classId = courseDataList["class"][0]._id;
              subjectId = courseDataList["subject"][classId] ? courseDataList["subject"][classId][0]._id : '';

              if (!_.isUndefined(subjectId))
                selectedGoal.selectedSubject = `${classId}_${subjectId}`;
            }

            if (!_.isEmpty(courseDataList["sub-subject"])) {
              subSubjectId = courseDataList["sub-subject"][subjectId] ? courseDataList["sub-subject"][subjectId][0]._id : "";
              selectedGoal.selectedSubSubject = `${subSubjectId}`;
            }

            if (!_.isEmpty(courseDataList["chapter"])) {
              chapterId = courseDataList["chapter"][subSubjectId] ? courseDataList["chapter"][subSubjectId][0]._id : "";
              selectedGoal.selectedChapter = `${chapterId}`;
            }

            if (courseDataList["concept"] && courseDataList["concept"].length > 0) {
              selectedGoal.selectedConcepts = `${courseDataList["concept"][0]._id}`;
            }
            this.setState({ selectedGoal });
          }
          this.setState({ courseDataList });
        } else {
          this.setState({ courseDataList: defaultCourseDataList });
        }
        this.calculateConceptMapping();
      }

    }
  }

  generateSequenceNumberForData(data: any) {
    let index = 1;
    let reqBody: any[] = [];

    data && data.class && data.class.forEach((classObj: any) => {
      data && data.subject && data.subject[classObj._id] && data.subject[classObj._id].forEach((classSubject: any) => {
        let seqNo = (index < 10) ? '0' + index.toString() : index.toString();
        classSubject.sequenceNumber = seqNo
        reqBody.push(classSubject);
        index = index + 1;
        if (! (data['sub-subject'][classSubject._id] && data['sub-subject'][classSubject._id][0].sequenceNumber)) {
          data['sub-subject'][classSubject._id] && data['sub-subject'][classSubject._id].forEach((subSubj: any) => {
            let order = _.get(subSubj, 'orderNo', 1)
            order = (order < 10) ? '0' + order.toString() : order.toString();
            subSubj.sequenceNumber = (classSubject.sequenceNumber) + order;
            reqBody.push(subSubj);

            if (! (data['chapter'][subSubj._id] && data['chapter'][subSubj._id][0].sequenceNumber)) {
              data['chapter'][subSubj._id] && data['chapter'][subSubj._id].forEach((chap: any) => {
                let order = _.get(chap, 'orderNo', 1)
                order = (order < 10) ? '0' + order.toString() : order.toString();
                chap.sequenceNumber = (subSubj.sequenceNumber) + order;
                reqBody.push(chap);

                if (!(data['concept'][chap._id] && data['concept'][chap._id][0].sequenceNumber)) {
                  data['concept'][chap._id] && data['concept'][chap._id].forEach((conceptObj: any) => {
                    let order = _.get(conceptObj, 'orderNo', 1)
                    order = (order < 10) ? '0' + order.toString() : order.toString();
                    conceptObj.sequenceNumber = (chap.sequenceNumber) + order;
                    reqBody.push(conceptObj);


                  })
                }


              })
            }

          })

        }

      })
    })
    if (reqBody && reqBody.length > 0) {
      GoalManagementService.updateCourse({ data: reqBody })
        .then((res) => {
          setTimeout(() => {
            this.props.getCourseData(this.state.activeCourse._id);
          }, 500);
        });
    }

  }
  handleMoreMenuOpen = (evt: any) => this.setState({ moreMenuAnchor: evt.currentTarget });
  handleMoreMenuClose = () => this.setState({ moreMenuAnchor: null });

  handleSelectedYearChange = (e: any) => {
    let { courseList, activeCourse, courseDataList, selectedGoal } = this.state;
    let { history } = this.props;
    let { value, key } = e.target;
    activeCourse = _.find(courseList, { '_id': value });

    history.push(`#${activeCourse._id}`)
    courseDataList = {
      "class": [],
      "subject": {},
      "sub-subject": {},
      "chapter": {},
      "concept": {}
    };

    selectedGoal = {
      selectedSubject: '',
      selectedSubSubject: '',
      selectedChapter: '',
      selectedConcepts: ''
    }

    this.setState({ activeCourse, courseDataList, selectedGoal });

    this.props.getCourseData(activeCourse._id);

  }


  handleSubjectSelect = (selectedS: string, type: string, evt: any) => {
    let { selectedGoal } = this.state;
    switch (type) {
      case 'selectedSubject':
        selectedGoal.selectedSubject = selectedS;
        selectedGoal.selectedSubSubject = "";
        selectedGoal.selectedChapter = "";
        selectedGoal.selectedConcepts = "";
        break;
      case 'selectedSubSubject':
        selectedGoal.selectedSubSubject = selectedS;
        selectedGoal.selectedChapter = "";
        selectedGoal.selectedConcepts = "";
        break;
      case 'selectedChapter':
        selectedGoal.selectedChapter = selectedS;
        selectedGoal.selectedConcepts = "";
        break;
      case 'selectedConcepts':
        selectedGoal.selectedConcepts = selectedS;
        break;
    }
    this.setState({ selectedGoal })
  };


  publishDialogEvent = (isShow: boolean, e: any) => {
    const buttonAction = e.currentTarget == undefined ? false : true;
    this.setState({ publishContent: isShow, showAddContent: buttonAction });
    if (e == true) {
      this.initi();
    }
  };

  subjectDialogEvent = (isShow: boolean) => this.setState({ subjectAdd: isShow });

  subSubjectDialogEvent = (isShow: boolean) => {
    if (isShow) {
      let { courseData } = this.props;
      let { selectedGoal, activeCourse, courseDataList, selectedSubjectDetail } = this.state;
      let ids = selectedGoal.selectedSubject.split("_");
      let classId = ids && ids.length > 0 ? ids[0] : "";
      let subjectId = ids && ids.length > 1 ? ids[1] : "";
      let classDetials = _.find(courseData, ['_id', classId]);
      selectedSubjectDetail = {};
      selectedSubjectDetail = _.find(courseDataList["subject"][classId], { '_id': subjectId });

      if (!_.isEmpty(selectedSubjectDetail)) {
        this.setState({ selectedSubjectDetail });
        let mastersIds = !_.isUndefined(selectedSubjectDetail["masterIDs"]) ? selectedSubjectDetail["masterIDs"].join(',') : '';
        this.props.getMaster('subSubject', mastersIds, _.get(classDetials, 'masterIDs.[0]', ''), activeCourse._id);
      }
    }
    this.setState({ subSubjectAdd: isShow });
    this.calculateConceptMapping();
  }

  chapterDialogEvent = (isShow: boolean) => {
    if (isShow) {
      let { courseData } = this.props;
      let { selectedGoal, activeCourse, courseDataList, selectedSubSubjectDetail } = this.state;
      if (!_.isUndefined(selectedGoal.selectedSubject) && !_.isUndefined(selectedGoal.selectedSubject)) {
        let id = selectedGoal.selectedSubSubject;
        let ids = selectedGoal.selectedSubject.split("_");
        let classId = ids && ids.length > 0 ? ids[0] : "";
        let subjectId = ids && ids.length > 1 ? ids[1] : "";
        let classDetials = _.find(courseData, ['_id', classId]);

        selectedSubSubjectDetail = {};
        selectedSubSubjectDetail = _.find(courseDataList["sub-subject"][subjectId], { '_id': id });


        if (!_.isEmpty(selectedSubSubjectDetail)) {
          this.setState({ selectedSubSubjectDetail });
          this.props.getMaster('chapter', selectedSubSubjectDetail["masterIDs"].join(','), _.get(classDetials, 'masterIDs.[0]', ''), activeCourse._id);
        }

      }
    }
    this.setState({ chapterAdd: isShow });
    this.calculateConceptMapping();

  }

  conceptDialogEvent = (isShow: boolean) => {
    if (isShow) {
      let { courseData } = this.props;
      let { selectedGoal, activeCourse, courseDataList, selectedChapter } = this.state;
      if (!_.isUndefined(selectedGoal.selectedChapter)) {
        let id = selectedGoal.selectedChapter;

        let ids = selectedGoal.selectedSubject.split("_");
        let classId = ids && ids.length > 0 ? ids[0] : "";
        let classDetials = _.find(courseData, ['_id', classId]);

        let subSubjectId = selectedGoal.selectedSubSubject;
        selectedChapter = _.find(courseDataList["chapter"][subSubjectId], { '_id': id });

        if (!_.isEmpty(selectedChapter)) {
          this.setState({ selectedChapter });
          this.props.getMaster('concept', selectedChapter["masterIDs"].join(','), _.get(classDetials, 'masterIDs.[0]', ''), activeCourse._id);
        }
      }
    }
    this.setState({ conceptAdd: isShow });
    this.calculateConceptMapping();

  }

  entityDialogEvent(isShow: boolean, selfId: string, currentUniqueCode?: any, orderNo?: number) {
    let { courseData } = this.props;
    let selfDetails: any = _.find(courseData, { '_id': selfId });

    if (selfDetails.isLocal) {
      this.localEntityDialogEvent(isShow, selfId);
    } else {
      this.masterEntityDialogEvent(isShow, selfId);
    }
    if (currentUniqueCode) {
      this.setState({ currentUniqueCode })
    }
    if (orderNo !== undefined) {
      this.setState({ orderNo })

    }
  }

  masterEntityDialogEvent = (isShow: boolean, selfId: string) => {
    let { selectedEntity, activeCourse }: any = this.state;
    let { courseData } = this.props;
    if (isShow) {
      if (!_.isEmpty(courseData)) {

        let selfDetails: any = _.find(courseData, { '_id': selfId });
        let childDetails = courseData.filter((cD: any) => cD.parent && cD.parent.id == selfId);
        let parentDetails = courseData.filter((cD: any) => cD._id == selfDetails["parent"]);


        selectedEntity["selfDetails"] = selfDetails;
        selectedEntity["childDetails"] = childDetails;
        selectedEntity["parentDetails"] = parentDetails;
      }


      selectedEntity["activeCourse"] = activeCourse;
      this.masterMap().then(mm => {
        selectedEntity.selfDetails = {
          ...selectedEntity.selfDetails,
          ...mm
        }
        this.setState({ masterEntity: isShow, selectedEntity });
      })
    } else {
      selectedEntity["activeCourse"] = activeCourse;
      this.setState({ masterEntity: isShow, selectedEntity });
    }
    this.setState({
      showError: false
    })
  };


  localEntityDialogEvent = (isShow: boolean, selfId: string) => {
    let { selectedGoal, selectedEntity, activeCourse }: any = this.state;
    let { courseData } = this.props;
    if (isShow) {
      if (!_.isEmpty(courseData)) {

        let selfDetails: any = _.find(courseData, { '_id': selfId });
        let childDetails = courseData.filter((cD: any) => cD.parent && cD.parent.id == selfId);
        let parentDetails = courseData.filter((cD: any) => cD._id == selfDetails["parent"]);
        let combineTo = courseData.filter((cD: any) => (
          _.get(cD, "masterIDs[0]", "") == _.get(selfDetails, "masterIDs[0]", "") &&
          cD._id != selfDetails._id &&
          (_.get(cD, "classes[0]", "1") == _.get(selfDetails, "classes[0]", "2") || _.get(cD, "class.id", "1") == _.get(selfDetails, "class.id", "2"))
        ));
        selfDetails["combineWith"] = combineTo;


        selectedEntity["selfDetails"] = selfDetails;
        selectedEntity["childDetails"] = childDetails;
        selectedEntity["parentDetails"] = parentDetails;
      }
    }
    selectedEntity["activeCourse"] = activeCourse;


    if (_.get(selectedEntity, "selfDetails.masterIDs[0]", "") && isShow) {
      let reqBody = {
        type: _.get(selectedEntity, "selfDetails.type", ""),
        ids: _.get(selectedEntity, "selfDetails.masterIDs", ""),
      }
      GoalManagementService.getMasters(reqBody)
        .then((r: any) => {
          selectedEntity["selfDetails"]["masters"] = r;
          this.setState({ localEntity: isShow, selectedEntity });
        })
    } else {
      selectedEntity["selfDetails"]["masters"] = [];
      this.setState({ localEntity: isShow, selectedEntity });
    }
    this.setState({
      showError: false
    })
  }

  LocalEntityUpdateHandler(newselfDetails: CourseSyllabusBody) {
    let { activeCourse } = this.state;
    _.isEmpty(newselfDetails) || _.isUndefined(newselfDetails._id) ? this.props.getCourseData(activeCourse._id) :
      this.props.updateCourseData(newselfDetails);
  }

  masterMap() {
    let formData: any = {};
    const { selectedEntity } = this.state;
    return GoalManagementService.getSyllabusByMaster(_.get(selectedEntity, 'selfDetails.masterIDs[0]', ''))
      .then((res: any) => {
        res = res.filter((r: any) => r.isLocal);
        //for splits into
        let splitsIntoGroup = _.groupBy(res, 'courseId');
        let splitsInto: any = {};
        for (var i in splitsIntoGroup) {
          if (splitsIntoGroup[i].length > 1) {
            let sig = splitsIntoGroup[i].filter(si => _.get(si, 'masterIDs.length', 0) == 1);
            if (sig.length > 1) {
              splitsInto[i] = sig;
            }
          }
        }
        formData['splitsInto'] = splitsInto;

        //to form master
        let formMaster = res.filter((r: any) => r.masterIDs.length > 1);
        formData['combineWith'] = formMaster;

        //alternateName
        let alternateName = res.filter((r: any) => (_.get(r, 'masterIDs[0]', "1") == _.get(selectedEntity, 'selfDetails.masterIDs[0]', '2') && _.get(r, 'name', "1") != _.get(selectedEntity, 'selfDetails.name', '2')));
        formData['alternateName'] = alternateName;

        let masters: string[] = [];
        formMaster.forEach((r: any) => {
          masters = masters.concat(_.get(r, 'masterIDs', []))
        })

        if (masters.length > 0) {

          let reqBody = {
            type: _.get(selectedEntity, 'selfDetails.type', ''),
            ids: masters,
          }
          return GoalManagementService.getMasters(reqBody)
            .then((r: any) => {
              selectedEntity["selfDetails"]["masters"] = r;
              return Promise.resolve(formData);
            })
        } else {
          selectedEntity["selfDetails"]["masters"] = [];
          return Promise.resolve(formData);
        }
      })
  }

  calculateConceptMapping() {
    let { courseDataList, mappedPer } = this.state;
    let { courseData } = this.props;
    let mappedPercentage: number = 0;
    let numerator: number = 0;
    let denominator: number = 0;

    numerator = courseData.filter(d => d.masterIDs && (d.masterIDs.length > 0)).length + courseData.filter(d => d.type === "class" && d.masterIDs && (d.masterIDs.length < 1)).length;
    denominator = courseData.length;
    mappedPercentage = ((numerator) / denominator) * 100;
    mappedPer = denominator ? parseInt(mappedPercentage + '') : 0;
    this.setState({ mappedPer });
  }

  handleDoubleClick(toRemoveId: string, classId: string = "", name: string, type: string, e: any) {
    const { showAddContent } = this.state;
    if (!showAddContent) {
      return
    }
    let ids: any = [];
    ids.push(toRemoveId)
    if (!_.isEmpty(classId)) {
      let { courseData } = this.props
      let isPresent: any = courseData.filter((c: any) => c.parent == classId);
      if (isPresent && isPresent.length == 1) {
        ids.push(classId);
      }
    }
    this.setState({ deleteDialog: { isDeleteDialogOpen: true, toRemoveId: ids, topicName: name, topicType: type } });
  }

  handleDoubleClickClass = (classData: any) => {
    this.setState({
      deleteDialog: {
        isDeleteDialogOpen: true,
        toRemoveId: [classData._id],
        topicName: `Class ${classData.name}`,
        topicType: 'class'
      }
    });
  }

  handleMapToMaster(unmap: any) {
    const { courseData, match, history } = this.props;
    let groupId = match.params.id;

    let parentId = '';
    if (_.isEmpty(unmap)) {
      parentId = _.get(unmap.find((c: any) => c.type == 'subject'), 'parent', '');
      if (_.isEmpty(parentId)) {
        parentId = _.get(unmap.find((c: any) => c.type == 'sub-subject'), 'parent', '');
        if (_.isEmpty(parentId)) {
          parentId = _.get(unmap.find((c: any) => c.type == 'chapter'), 'parent', '');
          if (_.isEmpty(parentId)) {
            parentId = _.get(unmap.find((c: any) => c.type == 'concept'), 'parent', '');
          }
        }
      }
    }
    let url = GoalManagementService.syncAndNext(parentId, unmap, courseData, groupId, courseData[0].courseId);
    history.push(url);
  }

  draggedItem: any = {};

  onDragStart = (evt: any, index: any, parentID: any, self: string) => {
    if (!parentID.id) {
      parentID.id = parentID._id;
    }
    const { showAddContent } = this.state;
    if (!showAddContent) {
      return
    }
    let { courseDataList } = this.state;
    let tempCourseDataList: any[] = courseDataList[self][parentID.id];
    this.draggedItem = tempCourseDataList[index];
    evt.dataTransfer.effectAllowed = 'move';
    evt.dataTransfer.setData("text/html", evt.target);
    evt.dataTransfer.setDragImage(evt.target, 0, 0);
  }

  onDragOver = (e: any, index: any, parentID: any, self: string) => {
    if (!parentID.id) {
      parentID.id = parentID._id;
    }
    const { showAddContent } = this.state;
    if (!showAddContent) {
      return
    }
    e.preventDefault();
    let { courseDataList } = this.state;
    let tempCourseDataList: any[] = courseDataList[self][parentID.id];
    let newCourseDataList: any[] = []
    let noId: any[] = [];
    let tempOrder = 0;
    let stop = false;
    const draggedOverItem = tempCourseDataList[index];
    if (this.draggedItem._id === draggedOverItem._id ||
      this.draggedItem.parent.id != draggedOverItem.parent.id || (_.isEmpty(this.draggedItem.masterIDs) != _.isEmpty(this.draggedItem.masterIDs))) {
        return;
    }
    if(self === 'subject'){
      courseDataList["class"].forEach( (classN: any, i: number) => {
        if(classN._id !== parentID.id && !stop) {
        tempOrder = tempOrder + courseDataList["subject"][classN._id].length
        } else {
          stop = true;
        }
      })
    }
    tempCourseDataList = tempCourseDataList.filter((item: any) => item._id !== this.draggedItem._id);
    tempCourseDataList.splice(index, 0, this.draggedItem);
    courseDataList[self][parentID.id] = tempCourseDataList;
    courseDataList[self][parentID.id] = courseDataList[self][parentID.id].map((cd: any, i: number) => { cd.orderNo = i + 1; return cd })
    if(self === 'subject') {
      courseDataList[self][parentID.id] = courseDataList[self][parentID.id].map((cd: any, i: number) => { cd.sequenceNumber = (tempOrder + cd.orderNo  < 10) ? '0' + (tempOrder + cd.orderNo).toString() : (tempOrder + cd.orderNo).toString(); return cd })

    }
    this.generateOrdering(courseDataList[self][parentID.id]);
    this.setState({ courseDataList });

  }
  onSequenceNumberEdit(dragIndex: number, parentID: any, self: string, dragOverIndex: number) {
    if (!parentID.id) {
      parentID.id = parentID._id;
    }
    let { courseDataList } = this.state;
    let tempCourseDataList: any[] = courseDataList[self][parentID.id];
    this.draggedItem = tempCourseDataList[dragIndex];
    let tempOrder = 0;
    let stop = false;
    let draggedOverItem: any;
    draggedOverItem = self === 'subject' ? courseDataList['subject'][parentID.id].filter((item: any) => item.sequenceNumber === dragOverIndex)[0] : tempCourseDataList[dragOverIndex];
    if ( !draggedOverItem || this.draggedItem._id === draggedOverItem._id ||
      this.draggedItem.parent.id != draggedOverItem.parent.id || (_.isEmpty(this.draggedItem.masterIDs) != _.isEmpty(this.draggedItem.masterIDs))) {
        this.setState({
          showError: true
        })
      return;
    }
  if(self === 'subject'){
    courseDataList["class"].forEach( (classN: any, i: number) => {
      if(classN._id !== parentID.id && !stop) {
      tempOrder = tempOrder + courseDataList["subject"][classN._id].length
      } else {
        stop = true;
      }
    })
  }
    tempCourseDataList = tempCourseDataList.filter((item: any) => item._id !== this.draggedItem._id);
    if(self !== 'subject'){
      tempCourseDataList.splice(dragOverIndex, 0, this.draggedItem);
    } else {
      tempCourseDataList.splice(draggedOverItem && draggedOverItem.orderNo - 1, 0, this.draggedItem);

    }
    courseDataList[self][parentID.id] = tempCourseDataList;

    courseDataList[self][parentID.id] = courseDataList[self][parentID.id].map((cd: any, i: number) => { cd.orderNo = i + 1; return cd })
    if(self === 'subject') {
      courseDataList[self][parentID.id] = courseDataList[self][parentID.id].map((cd: any, i: number) => { cd.sequenceNumber = (tempOrder + cd.orderNo  < 10) ? '0' + (tempOrder + cd.orderNo).toString() : (tempOrder + cd.orderNo).toString(); return cd })

    }
    this.generateOrdering(courseDataList[self][parentID.id]);
    this.setState({ courseDataList });
  }
  handleError() {
    this.setState({
      showError: false
    })
  }
  generateOrdering(changedCourseData: any[]) {
    let { courseData } = this.props;
    let { activeCourse } = this.state;
    let reqBody: any[] = [];
    //FIXME:When you change in this kindly change in changeOrdering
    changedCourseData.forEach((cd: any) => {
      let changeId = "";
      let oldUniqueCode = "";
      let oldSequenceNo = "";
      let newSequenceNo = "";
      let newUniqueCode = "";
      let childDat: any[] = [];
      changeId = cd._id;
      oldUniqueCode = cd.uniqueCode.replace(CodeInitials[cd.type], '');
      oldSequenceNo = cd.sequenceNumber;
      cd.uniqueCode = cd.uniqueCode.substring(0, cd.uniqueCode.length - 2);
      cd.uniqueCode += cd.orderNo < 10 ? `0${cd.orderNo}` : cd.orderNo;
      if(cd.type !== 'subject') {
      let code = oldSequenceNo
      code = code.substring(0, oldSequenceNo.length - 2)
      newSequenceNo = (cd.orderNo < 10) ? code + '0' + cd.orderNo.toString() : code + cd.orderNo.toString();
      cd.sequenceNumber = newSequenceNo;  
    } else {
      newSequenceNo = cd.sequenceNumber
    }
      newUniqueCode = cd.uniqueCode.replace(CodeInitials[cd.type], '');
      childDat = courseData.filter((dd: any) => dd.ancestors.includes(changeId));
      reqBody.push(cd);

      //For ancestors
      if (changeId && childDat.length > 0) {
        childDat.forEach((chd: any) => {
          chd.uniqueCode = chd.uniqueCode.replace(oldUniqueCode, newUniqueCode);
          let order = _.get(chd, 'orderNo', 1)
          order = (order < 10) ? '0' + order.toString() : order.toString();
          if(cd.type !== 'subject') {
          chd.sequenceNumber = newSequenceNo + order;
          } else {
            chd.sequenceNumber = chd.sequenceNumber.replace(/^.{2}/g, newSequenceNo);
          }
          reqBody.push(chd);
        });
      }

    });

    GoalManagementService.updateCourse({ data: reqBody })
      .then((res) => {
        this.props.getCourseData(activeCourse._id);
      })
  }

  onDragEnd = () => {
    const { showAddContent } = this.state;
    if (showAddContent) {
      return
    }
    this.draggedItem = {};
  }

  handleUnarchive = (activeCourse: any) => {
    GoalManagementService.archiveCourse(activeCourse._id, 'unarchive=true')
      .then((res) => {
        this.props.history.push(`/goal-management`)
      })
  }

  handleShowAddContent = () => {
    if (this.props.isPostExpiryDays) {
      this.props.toggleLicenseExpiredDialog(true);
    } else {
      this.setState({ showAddContent: !this.state.showAddContent })
    }
    // const { showAddContent } = this.state;
    // this.props.setShowAddContent(!showAddContent);
  }

  checkNullOrUndefined = (value: any) => {
    if (value === null || value === undefined) {
      return '';
    }
    return value;
  }

  handleExportMasterCodeList = (courseId: string) => {

    let newFormattedCSV: any = [];
    let { name: activeCourseName } = this.state.activeCourse;

    GoalManagementService.exportMasterCodeList(courseId).then(
      (res: any) => {
        newFormattedCSV = res
          .filter((obj: any) => obj.type !== "class")
          .map((obj: any) => {
            const csvObj: any = {};
            csvObj["Subject"] = this.checkNullOrUndefined(obj.subjectData.name);
            csvObj["Subject Code"] = this.checkNullOrUndefined(obj.subjectData.uniqueCode);
            csvObj["Master Subject"] = this.checkNullOrUndefined(obj.masterSubject.name);
            csvObj["Master Subject Code"] = this.checkNullOrUndefined(obj.masterSubject.id);
            csvObj["Sub-Subject"] = this.checkNullOrUndefined(obj.subSubjectData.name);
            csvObj["Sub-Subject Code"] = this.checkNullOrUndefined(obj.subSubjectData.uniqueCode);
            csvObj["Master Sub-Subject"] = this.checkNullOrUndefined(obj.masterSubSubject.name);
            csvObj["Master Sub-Subject Code"] = this.checkNullOrUndefined(obj.masterSubSubject.id);
            csvObj["Chapter"] = this.checkNullOrUndefined(obj.chapterData.name);
            csvObj["Chapter Code"] = this.checkNullOrUndefined(obj.chapterData.uniqueCode);
            csvObj["Master Chapter"] = this.checkNullOrUndefined(obj.masterChapter.name);
            csvObj["Master Chapter Code"] = this.checkNullOrUndefined(obj.masterChapter.id);
            csvObj["Concept"] = this.checkNullOrUndefined(obj.conceptName);
            csvObj["Concept Code"] = this.checkNullOrUndefined(obj.conceptCode);
            csvObj["Master Concept"] = this.checkNullOrUndefined(obj.masterConcept.name);
            csvObj["Master Concept Code"] = this.checkNullOrUndefined(obj.masterConcept.conceptCode);
            csvObj["Master Concept Id"] = this.checkNullOrUndefined(obj.masterConcept.conceptId);
            return csvObj;
          });
        const options = {
          fieldSeparator: ",",
          quoteStrings: '"',
          decimalSeparator: ".",
          showLabels: true,
          useTextFile: false,
          useBom: true,
          useKeysAsHeaders: true,
          filename: `${activeCourseName}_codelist`
        };
        const csvExporter = new ExportToCsv(options);
        csvExporter.generateCsv(newFormattedCSV);
      }
    );
  }
  getCountValue(type: string) {
    let {selectedGoal, courseDataList, selectedEntity } = this.state;
    let count = 0;
    if(type === 'sub-subject') {
    let subjectIds = selectedGoal.selectedSubject ? selectedGoal.selectedSubject.split('_')[1] : "";
    let data = courseDataList["sub-subject"][subjectIds];
    if (data) {
      count = data.length
    }
  } else if(type === 'subject') {
      courseDataList["class"].forEach( (classN: any, i: number) => {
        count = count + courseDataList["subject"][classN._id].length
    })
  } else if(type === 'chapter') {
    _.map(courseDataList["chapter"][selectedGoal.selectedSubSubject], (chapter, i) => {
      count = courseDataList["chapter"][selectedGoal.selectedSubSubject].length;
  })
  } else {
    _.map(courseDataList["concept"][selectedGoal.selectedChapter], (concept, i) => {
      count = courseDataList["concept"][selectedGoal.selectedChapter].length
    })
  }
  return count
}
  render() {
    const { classes, courseData } = this.props;
    const {
      moreMenuAnchor,
      selectedGoal,
      subjectAdd,
      subSubjectAdd,
      courseDataList,
      chapterAdd,
      conceptAdd,
      publishContent,
      courseList,
      activeCourse,
      selectedChapter,
      selectedSubjectDetail,
      selectedSubSubjectDetail,
      mappedPer,
      masterEntity,
      localEntity,
      showAddContent,
      selectedEntity,
      deleteDialog,
      goalDialogOpen,
      dialogData,
      goalList,
      years,
      actionType
    } = this.state;
    let [subjectCount, subSubjectCount, chapterCount, conceptCount] = [0, 0, 0, 0]
    const unmap = courseData && courseData.filter((c: any) => c.masterIDs.length == 0);
    let tempCourseData = _.cloneDeep(courseDataList);

    let showSubSubject = () => {
      let subjectIds = selectedGoal.selectedSubject ? selectedGoal.selectedSubject.split('_')[1] : "";
      let data = courseDataList["sub-subject"][subjectIds];
      if (data) {
        subSubjectCount = data.length
      }
      return _.map(data, (subSubject, i) =>
        !_.isEmpty(subSubject["masterIDs"]) &&
        <ListItem

          key={`${subSubject._id}_${i}`}
          className={`${selectedGoal.selectedSubSubject == subSubject._id ? classes.activeSelected : ""} ${classes.listItemWrapper}`}
          selected={selectedGoal.selectedSubSubject == subSubject._id ? true : false}
          divider
          button>
            <div
            onDragStart={(e) => this.onDragStart(e, i, subSubject.parent, "sub-subject")}
            onDrop={(e) => this.onDragOver(e, i, subSubject.parent, "sub-subject")}
            onDragEnd={this.onDragEnd}
            onDragOver={(e) => { e.preventDefault() }}
            draggable
            style={{display: "flex"}}
            >

          
{ showAddContent && <ListItemIcon classes={{root: "listItemIcon"}}>
               <DragIndicatorIcon />
</ListItemIcon>}
<ListItemText
            primaryTypographyProps={{ variant: 'body1', noWrap: true }}
          >
            <div
              className={showAddContent ? classes.listItemLabel : classes.listItemLabelWithoutEdit}
              onClick={this.handleSubjectSelect.bind(this, subSubject._id, 'selectedSubSubject')}
              onDoubleClick={(e: any) => { this.handleDoubleClick(subSubject._id, '', subSubject.name, 'Sub Subject', e) }}
            >
              {`${_.get(subSubject, 'orderNo', '')}. ${subSubject.name}`}
            </div>
            <Typography
              noWrap
              onClick={this.entityDialogEvent.bind(this, true, subSubject._id, subSubject.uniqueCode, subSubject.orderNo)}
              variant="caption" className={classes.smallText}>
              {_.get(subSubject, 'uniqueCode', '')}
            </Typography>
          </ListItemText>

          </div>
        </ListItem>
      )
    }

    let showSubSubjectUnmapped = () => {
      let parentID = selectedGoal.selectedSubject ? selectedGoal.selectedSubject.split('_') : "";
      let classId = parentID && parentID.length > 0 ? parentID[0] : "";
      let subjectId = parentID && parentID.length == 2 ? parentID[1] : "";
      let selectedSubjectDetail = _.find(courseDataList["subject"][classId], { '_id': subjectId });
      let subjectMasterId = _.get(selectedSubjectDetail, 'masterIDs', []);

      let classDetials = _.find(courseData, ['_id', classId]);

      let data = courseDataList["sub-subject"][subjectId];
      let isUnmappedPresent = data ? data.filter((d: any) => d["masterIDs"].length == 0) : [];

      return (
        !_.isEmpty(isUnmappedPresent) &&
        <List
          component="nav"
          subheader={
            <Grid container alignContent="flex-start">
              <Grid item xs={10}>
                <Typography component="div" className={classes.umMappedHeader} variant="subtitle1" align="left">Unmapped Sub Subjects</Typography>
              </Grid>
              <Grid className={classes.pT6} item xs={2}>
                <MyPATLink to={`/sub-subject-mapping/${subjectId}/${_.get(_.find(isUnmappedPresent, 'courseId'), 'courseId', '')}/${_.get(classDetials, 'masterIDs.[0]', '')}/${_.isEmpty(subjectMasterId) ? 'noClass' : subjectMasterId.join(',')}/${activeCourse.groupId}`}><Button color="primary">Map</Button></MyPATLink>
              </Grid>
            </Grid>
          }
          className={classes.root}
        >
          {
            _.map(data, (subSubject, j) => (
              _.isEmpty(subSubject["masterIDs"]) &&
              <ListItem
                
                key={`${subSubject._id}_${j}`}
                divider
                className={`${selectedGoal.selectedSubSubject == subSubject._id ? classes.activeSelected : classes.notMapped} ${classes.listItemWrapper}`}
              >
                <div
                draggable
                onDragStart={(e) => this.onDragStart(e, j, subSubject.parent, "sub-subject")}
                onDrop={(e) => this.onDragOver(e, j, subSubject.parent, "sub-subject")}
                onDragEnd={this.onDragEnd}
                onDragOver={(e) => { e.preventDefault() }}
                style={{display: "flex"}}
                >
                { showAddContent && <ListItemIcon classes={{root: "listItemIcon"}}>
               <DragIndicatorIcon />
</ListItemIcon>}
<ListItemText
                  primaryTypographyProps={{ variant: 'body1', noWrap: true }}
                >

                  <div
                    className={showAddContent ? classes.listItemLabel : classes.listItemLabelWithoutEdit}
                    onDoubleClick={(e: any) => { this.handleDoubleClick(subSubject._id, '', subSubject.name, 'Sub Subject', e) }}

                    onClick={this.handleSubjectSelect.bind(this, subSubject._id, 'selectedSubSubject')}
                  >
                    {`${_.get(subSubject, 'orderNo', '')}. ${subSubject.name}`}
                  </div>

                  <Typography
                    noWrap
                    onClick={this.entityDialogEvent.bind(this, true, subSubject._id, subSubject.uniqueCode, subSubject.orderNo)}
                    variant="caption" className={classes.uniqueCodeLabel}>{_.get(subSubject, 'uniqueCode', '')}
                  </Typography>

                </ListItemText>
                </div>
              </ListItem>
            )
            )
          }
          <Typography variant="body2" className={classes.unmappedInfo}>Unmapped topics will be added as new topics in the master sub subject list</Typography>
        </List>
      )
    }

    let chapterLink = () => {
      //Get parent id seclected
      let parentID = selectedGoal.selectedSubSubject ? selectedGoal.selectedSubSubject : "";
      //Need class id also so that chapter releted to that class can be filter at api level
      let classSubjectId = selectedGoal.selectedSubject ? selectedGoal.selectedSubject : "";
      let classId = classSubjectId ? classSubjectId.split('_')[0] : "";
      let classDetials = _.find(courseData, ['_id', classId]);
      //Is unmapped data present under chapter
      let data = courseDataList["chapter"][parentID];
      let isUnmappedPresent = data ? data.filter((d: any) => d["masterIDs"].length == 0) : [];

      //Course id needed to get all unmapped data at mapping page
      let courseId = _.get(_.find(isUnmappedPresent, 'courseId'), 'courseId', '');

      //get master id from parent object inside masterIds.
      let subSubjectMasterId: any[] = _.get(_.find(courseData, ['_id', parentID]), 'masterIDs', []);

      return `/chapter-mapping/${parentID}/${courseId}/${_.get(classDetials, 'masterIDs.[0]', '')}/${_.isEmpty(subSubjectMasterId) ? 'noClass' : subSubjectMasterId.join(',')}/${activeCourse.groupId}`;
    };

    let conceptLink = () => {

      //Get parent id seclected
      let parentID = selectedGoal.selectedChapter ? selectedGoal.selectedChapter : "";
      //Need class id also so that chapter releted to that class can be filter at api level
      let classSubjectId = selectedGoal.selectedSubject ? selectedGoal.selectedSubject : "";
      let classId = classSubjectId ? classSubjectId.split('_')[0] : "";
      let classDetials = _.find(courseData, ['_id', classId]);
      //Is unmapped data present under chapter
      let data = courseDataList["concept"][parentID];
      let isUnmappedPresent = data ? data.filter((d: any) => d["masterIDs"].length == 0) : [];

      //Course id needed to get all unmapped data at mapping page
      let courseId = _.get(_.find(isUnmappedPresent, 'courseId'), 'courseId', '');

      //get master id from parent object inside masterIds.
      let chapterMasterIds: any = _.get(_.find(courseData, ['_id', parentID]), 'masterIDs', []);
      return `/concept-mapping/${parentID}/${courseId}/${_.get(classDetials, 'masterIDs.[0]', '')}/${_.isEmpty(chapterMasterIds) ? 'noClass' : chapterMasterIds.join(',')}/${activeCourse.groupId}`;
    }

    // let showChapter = (chapter: any) => {
    //   let show = false;
    //   let subSubjectId: any = selectedGoal.selectedSubSubject ? selectedGoal.selectedSubSubject : "";
    //   show = chapter["parent"] && chapter["parent"].includes(subSubjectId);
    //   return show;
    // }

    const getCount = (data: any) => {
      let count = 0;
      if (Object.keys(data).length) {
        Object.keys(data).forEach(key => {
          count += data[key].length;
        })
      }
      return count;
    }



    const getEditGoalStatus = () => {
      const { activeCourse } = this.state;
      if (activeCourse && activeCourse.packageExist) {
        if (new Date() <= new Date(activeCourse.endDate)) {
          return <Grid className={[classes.live, classes.draftBtn].join(' ')}>Live</Grid>;
        } else {
          return <Grid className={[classes.expired, classes.draftBtn].join(' ')}>Expired</Grid>;
        }
      } else if (activeCourse && activeCourse.status && activeCourse.status.toLowerCase() === 'published') {
        return <Grid className={[classes.published, classes.draftBtn].join(' ')}>Published</Grid>;
      }
      else {
        return <Grid className={[classes.draft, classes.draftBtn].join(' ')}>Draft</Grid>;
      }
    };

    return (
      <>
        <Grid container spacing={8} alignItems="center" justify="space-between" className={classes.mb2x}>
          <Grid item >
            <Grid container alignItems="center" className={classes.pageTitle}>
              <MyPATLink to={"/goal-management"}>
                <BackIcon />
              </MyPATLink>
              <Typography variant="h6" classes={{ root: classes.title }} noWrap>{_.get(activeCourse, 'courseType.name', '')}</Typography>
              <MyPATSelect
                selectMinWidth
                value={activeCourse && activeCourse._id}
                onChange={this.handleSelectedYearChange.bind(this)}
              >
                {_.map(courseList, (courseYear: any, i: number) =>
                  <option key={courseYear._id} value={courseYear._id}>{courseYear.targetYear}</option>
                )}
              </MyPATSelect>
              <Typography variant="h4" inline onClick={(event) => this.handleViewGoalDialogOpen(event, activeCourse._id)} className={classes.infoIcon}>{<InfoIcon fontSize="large" />}</Typography>
              {getEditGoalStatus()}
              {!showAddContent && this.props.courseData.length ?
              <Grid style={{ display: "flex",marginLeft:5,}}>
                      <img src="/assets/svg/goalManagement/download.svg"  onClick={() => this.handleExportMasterCodeList(activeCourse._id)}
                      style={{cursor:"pointer",width:"23px"}}/>
                   </Grid> : null
              }
            </Grid>
          </Grid>

          <Grid item style={{display:"flex"}}>
            {
              this.state.showAddContent == false ?
                <ResponseBasedACL
                  response={_.get(this.state, 'activeCourse.aclMetaData', {})}
                  responseKey='createdBy'
                  checkBoth={false}
                  layerType={['COURSE']}
                  accessType={['EDIT']}
                >
                  {
                    activeCourse && activeCourse.isDeleted ?
                      <Button
                        variant="contained"
                        color="primary"
                        className={classes.btnAddNewGoal}
                        onClick={() => { this.handleUnarchive(activeCourse) }}
                      >
                        Retrieve
                      </Button>
                      :
                      <>
                      {/* <Grid className={classes.btnAddNewGoal}>
                        <img src="/assets/svg/goalManagement/attachement.svg" />
                      </Grid> */}
                      {/* <Grid className={classes.btnAddNewGoal}>
                        <img src="/assets/svg/goalManagement/download.svg" />
                      </Grid> */}
                      {/* <Button
                        variant="outlined"
                        className={[classes.btnAddNewGoal, classes.borderBlueBtn].join(' ')}
                        onClick={() => this.handleMapToMaster(unmap)}
                      >
                          Map to Master
                      </Button> */}
                      <Button
                        variant="contained"
                        color="primary"
                        className={classes.btnAddNewGoal}
                        disabled={!ACLService.checkModulePermission("goal","edit")}
                        onClick={() => {  this.handleShowAddContent()  }}
                      >
                          Edit Version
          				    </Button>
                      </>
                  }

                </ResponseBasedACL> : ''}

            {
              this.state.showAddContent && !_.isEmpty(courseDataList.subject) ?
                <>
                <Grid style={{display:"flex"}}>
                  {unmap.length == 0 ? '' :
                   
                   <Grid style={{ display: "flex",marginLeft:5,marginRight:15,}}>
                    <img src="/assets/svg/goalManagement/attachement.svg" onClick={() => this.handleMapToMaster(unmap)}
                    style={{cursor:"pointer"}}/>
                 </Grid>
                
                  }
                  <Button
                    variant="contained"
                    color="primary"
                    className={[classes.btnAddNewGoal, classes.greenBackgroundColor].join(' ')}
                    onClick={this.publishDialogEvent.bind(this, true)}
                  >
                    Publish
          </Button>
          </Grid>
                </> : ''

            }
            <MyPATIconButton
              buttonVariant="bordered"
              aria-haspopup="true"
              onClick={this.handleMoreMenuOpen.bind(this)}
            >
              <MoreIcon />
            </MyPATIconButton>
            <Menu
              open={Boolean(moreMenuAnchor)}
              anchorEl={moreMenuAnchor}
              onClose={this.handleMoreMenuClose.bind(this)}
              className={classes.moreMenu}
            >
              <MenuItem onClick={this.handleMoreMenuClose.bind(this)}>
                Menu Item
            </MenuItem>
            </Menu>
          </Grid>
        </Grid>


        <Grid container className={classes.contentContainer} alignItems="center" justify="space-between">
          <Grid item xs="auto">
            <Typography variant="h6">Content</Typography>
          </Grid>
          <Grid item xs="auto">

          </Grid>
          <Grid item>

            <div className={classes.progressWrapper}>
              <Typography variant="body1">Concept Mapping {mappedPer}%</Typography>
              <LinearProgress className={classes.progressBar} variant="determinate" value={mappedPer} />
            </div>
          </Grid>
        </Grid>

        <Grid container className={classes.root} spacing={16} alignItems="flex-start">
          <Grid item xs={12} className={classes.marginTop30}>
            <Grid container justify="flex-start" spacing={8}>
              {/* Subject Start */}
              <Grid item xs={3} className={classes.padding2x}>
                  <Grid container justify="space-between" className={classes.mb1x}>
                    <Grid item>
                      <Typography variant="h5" align="left" className={classes.fontSize20}>Subjects</Typography>
                    </Grid>
                    <Grid item>
                      {
                        showAddContent && 
                           <AddCircleOutlineIcon onClick={this.subjectDialogEvent.bind(this, true)} color="primary" className={[classes.blueColor, classes.cursorPointer].join(' ')} />
                      }
                    </Grid>
                  </Grid>
                  {/* <Grid item xs={2}>
                      {
                        showAddContent && <ACL
                          layerType={['COURSE']}
                          accessType={['ADD', 'EDIT']}
                        >
                          <Button onClick={this.subjectDialogEvent.bind(this, true)} color="primary">Add</Button>
                        </ACL>
                      }
                    </Grid> //Just for fucture purpose */
                  }
                <Grid container className={classes.gridMinHeight}>
                  <Grid item xs={12} >
                    <Paper className={cx(classes.paper, classes.firstPaper)}>
                      <Grid className={classes.paper}>
                        {
                          _.map(courseDataList["class"], (classN, i) => {
                            return (
                              <>
                                <List
                                  key={`subject_${classN}_${i}`}
                                  component="nav"
                                  subheader={
                                    <Typography
                                      component="div"
                                      className={classes.subHeader}
                                      variant="subtitle1"
                                      align="left"
                                      style={{ cursor: 'pointer' }}
                                      onDoubleClick={(e: any) => { this.handleDoubleClickClass(classN) }}
                                    >
                                      Class {classN.name}
                                    </Typography>}
                                  className={classes.root}
                                >
                                  {

                                    _.map(courseDataList["subject"][classN._id], (sub: any, j: number) => (
                                      !_.isEmpty(sub.masterIDs) &&
                                      <ListItem
                                       
                                        key={`${sub._id}_${i}`}
                                        selected={selectedGoal.selectedSubject == `${classN._id}_${sub._id}` ? true : false}
                                        className={`${selectedGoal.selectedSubject == `${classN._id}_${sub._id}` ? classes.activeSelected : ""} ${classes.listItemWrapper}`}
                                        divider
                                        button >
                                          <div
                                           draggable
                                           onDragStart={(e) => this.onDragStart(e, j, classN, "subject")}
                                           onDrop={(e) => this.onDragOver(e, j, classN, "subject")}
                                           onDragEnd={this.onDragEnd}
                                           onDragOver={(e) => { e.preventDefault() }}
                                           style={{display: "flex"}}
                                          >
                                        { showAddContent && <ListItemIcon classes={{root: "listItemIcon"}}>
               <DragIndicatorIcon />
</ListItemIcon> }
<ListItemText
                                          primaryTypographyProps={{ variant: 'body1', noWrap: true }}
                                        >
                                          <Typography
                                            noWrap
                                            onClick={this.entityDialogEvent.bind(this, true, sub._id, sub.uniqueCode, sub.orderNo)}
                                            variant="caption" className={classes.smallText}>{_.get(sub, 'uniqueCode', '')}</Typography>

                                          <div
                                            className={showAddContent ? classes.listItemLabel : classes.listItemLabelWithoutEdit}
                                            onClick={this.handleSubjectSelect.bind(this, `${classN._id}_${sub._id}`, 'selectedSubject')}
                                            onDoubleClick={this.handleDoubleClick.bind(this, sub._id, classN._id, sub.name, 'Subject')}

                                          >
                                            {`${_.get(sub, 'orderNo', '')}. ${sub.name}`}
                                          </div>
                                        </ListItemText>
                                        </div>
                                      </ListItem>
                                    )
                                    )
                                  }

                                  {
                                    !_.isEmpty(_.find(courseDataList["subject"][classN._id], function (c: any) { return _.get(c, "masterIDs", []).length == 0 }))
                                    &&
                                    <List
                                      component="nav"
                                      subheader={
                                        <Grid container alignContent="flex-start">
                                          <Grid item xs={10}>
                                            <Typography component="div" className={classes.umMappedHeader} variant="subtitle1" align="left">Unmapped Subjects</Typography>
                                          </Grid>
                                          <Grid className={classes.pT6} item xs={2}>
                                            <MyPATLink to={`/subject-mapping/${classN._id}/${classN.courseId}/${_.isEmpty(_.get(classN, 'masterIDs', [])) ? 'noClass' : _.get(classN, 'masterIDs', []).join(',')}/${activeCourse.groupId}`}><Button color="primary">Map</Button></MyPATLink>
                                          </Grid>
                                        </Grid>
                                      }
                                      className={classes.root}
                                    >
                                      {

                                        _.map(courseDataList["subject"][classN._id], (subjects, j) => {
                                          subjectCount = courseDataList["subject"][classN._id].length
                                                return !_.isUndefined(subjects.isLocal) && _.isEqual(subjects.isLocal, true) &&
                                            _.isEmpty(subjects.masterIDs) &&
                                            <ListItem

                                              key={`${subjects._id}_${j}`}
                                              divider
                                              className={`${selectedGoal.selectedSubject == `${classN._id}_${subjects._id}` ? classes.activeSelected : classes.notMapped} ${classes.listItemWrapper}`}
                                            > 
                                            <div
                                            style={{display: "flex"}}
                                            draggable
                                            onDragStart={(e) => this.onDragStart(e, j, classN, "subject")}
                                            onDrop={(e) => this.onDragOver(e, j, classN, "subject")}
                                            onDragOver={(e) => { e.preventDefault() }}
                                            onDragEnd={this.onDragEnd}
                                            >
                                              { showAddContent && <ListItemIcon classes={{root: "listItemIcon"}}>
                                            <DragIndicatorIcon />
                                                   </ListItemIcon>}
                                                  <ListItemText
                                                primaryTypographyProps={{ variant: 'body1', noWrap: true }}
                                              >

                                                <div
                                                  className={showAddContent ? classes.listItemLabel : classes.listItemLabelWithoutEdit}
                                                  onDoubleClick={this.handleDoubleClick.bind(this, subjects._id, classN._id, subjects.name, 'Subject')}

                                                  onClick={this.handleSubjectSelect.bind(this, `${classN._id}_${subjects._id}`, 'selectedSubject')}
                                                >
                                                  {`${_.get(subjects, 'orderNo', '')}. ${subjects.name}`}
                                                </div>
                                                <Typography
                                                  onClick={this.entityDialogEvent.bind(this, true, subjects._id, subjects.uniqueCode, subjects.orderNo)}
                                                  noWrap
                                                  variant="caption" className={classes.smallText}>{_.get(subjects, 'uniqueCode', '')}
                                                </Typography>
                                              </ListItemText></div>
                                            </ListItem>
                                        })
                                      }
                                      <Typography variant="body2" className={classes.unmappedInfo}>Unmapped topics will be added as new topics in the master subject list</Typography>
                                    </List>
                                  }
                                </List>
                              </>
                            )
                          })
                        }
                      </Grid>
                      <Grid container justify="center" alignItems="center" className={classes.countContentCard}>
                        <Typography align="center">{
                          getCount(courseDataList['subject'])
                        } Subject Overall</Typography>
                      </Grid>
                    </Paper>
                  </Grid>
                </Grid>
              </Grid>
              {/* Subject End   */}

              {/* Sub Subjects */}
              <Grid item xs={3} className={classes.padding2x}>
                  <Grid container xs={12} justify="space-between" className={classes.mb1x}>
                    <Grid item>
                      <Typography variant="h5" align="left" className={classes.fontSize20}>Sub Subjects</Typography>
                    </Grid>
                    <Grid item>
                      {
                        showAddContent &&
                         <AddCircleOutlineIcon onClick={this.subSubjectDialogEvent.bind(this, true)} color="primary" className={[classes.blueColor, classes.cursorPointer].join(' ')} />
                        
                      }
                    </Grid>
                  </Grid>
                  {/* <Grid item xs={2}> //Future Purpose
                      {
                        showAddContent &&
                        <ACL
                          layerType={['COURSE']}
                          accessType={['ADD', 'EDIT']}
                        >
                          <Button onClick={this.subSubjectDialogEvent.bind(this, true)} color="primary" disabled={_.isEmpty(selectedGoal.selectedSubject)}>Add</Button>
                        </ACL>
                      }
                    </Grid> */}
                <Grid container className={classes.gridMinHeight}>
                  <Grid item xs={12} >
                    <Paper className={classes.paper}>
                      {
                        <>
                          <Grid className={classes.cardMinHeigth}>
                            <List>
                              {showSubSubject()}
                            </List>
                            {showSubSubjectUnmapped()}
                          </Grid>
                          <Grid container justify="center" alignItems="center" className={classes.countContentCard}>
                            <Typography align="center">{
                              subSubjectCount
                            } Sub Subject </Typography>
                          </Grid>
                        </>
                      }
                    </Paper>
                  </Grid>
                </Grid>
              </Grid>
              {/*End Sub Subjects */}


              {/* Chapters */}
              <Grid item xs={3} className={classes.padding2x}>
                  <Grid container xs={12} justify="space-between" className={classes.mb1x}>
                    <Grid item>
                      <Typography variant="h5" align="left" className={classes.fontSize20}>Chapters</Typography>
                    </Grid>
                    <Grid item>
                      {
                        showAddContent && 
                         <AddCircleOutlineIcon onClick={this.chapterDialogEvent.bind(this, true)} color="primary" className={[classes.blueColor, classes.cursorPointer].join(' ')} />
                      }
                    </Grid>
                  </Grid>
                  {/* <Grid item xs={2}> //Future purpose
                      {
                        showAddContent &&
                        <ACL
                          layerType={['COURSE']}
                          accessType={['ADD', 'EDIT']}
                        >
                          <Button onClick={this.chapterDialogEvent.bind(this, true)} color="primary" disabled={_.isEmpty(selectedGoal.selectedSubSubject)}>Add</Button>
                        </ACL>
                      }
                    </Grid> */}
                <Grid container className={classes.gridMinHeight}>
                  <Grid item xs={12}>
                    <Paper className={classes.paper}>
                      {
                        <>
                          <Grid className={classes.cardMinHeigth}>
                            <List>
                              {
                                _.map(courseDataList["chapter"][selectedGoal.selectedSubSubject], (chapter, i) => {
                                  chapterCount = courseDataList["chapter"][selectedGoal.selectedSubSubject].length;
                                      return !_.isEmpty(chapter.masterIDs) &&
                                    <ListItem

                                      key={`${chapter._id}_${i}`}
                                      selected={selectedGoal.selectedChapter == chapter._id ? true : false}
                                      className={`${selectedGoal.selectedChapter == chapter._id ? classes.activeSelected : ""} ${classes.listItemWrapper}`}
                                      divider
                                      button >
                                                                                    <div
                                            style={{display: "flex"}}
                                            draggable
                                            onDragStart={(e) => this.onDragStart(e, i, chapter.parent, "chapter")}
                                            onDrop={(e) => this.onDragOver(e, i, chapter.parent, "chapter")}
                                            onDragOver={(e) => { e.preventDefault() }}
                                            onDragEnd={this.onDragEnd}
                                            >
                                      { showAddContent && <ListItemIcon classes={{root: "listItemIcon"}}>
               <DragIndicatorIcon />
</ListItemIcon>}
<ListItemText
                                        primaryTypographyProps={{ variant: 'body1', noWrap: true }}
                                      >
                                        <Typography
                                          noWrap
                                          onClick={this.entityDialogEvent.bind(this, true, chapter._id, chapter.uniqueCode, chapter.orderNo)}
                                          variant="caption" className={classes.smallText}>{_.get(chapter, 'uniqueCode', '')}</Typography>
                                        <div
                                          className={showAddContent ? classes.listItemLabel : classes.listItemLabelWithoutEdit}
                                          onClick={this.handleSubjectSelect.bind(this, chapter._id, 'selectedChapter')}
                                          onDoubleClick={this.handleDoubleClick.bind(this, chapter._id, '', chapter.name, 'Chapter')}

                                        >
                                          {`${_.get(chapter, 'orderNo', '')}. ${chapter.name}`}
                                        </div>
                                      </ListItemText>
                                      </div>
                                    </ListItem>
                                }
                                )

                              }
                            </List>
                            {
                              !_.isEmpty(_.find(courseDataList["chapter"][selectedGoal.selectedSubSubject], function (c: any) { return c["masterIDs"].length == 0 }))
                              &&
                              <List
                                component="nav"
                                subheader={
                                  <Grid container alignContent="flex-start">
                                    <Grid item xs={10}>
                                      <Typography component="div" className={classes.umMappedHeader} variant="subtitle1" align="left">Unmapped Chapters</Typography>
                                    </Grid>
                                    <Grid className={classes.pT6} item xs={2}>
                                      <MyPATLink to={chapterLink()}><Button color="primary">Map</Button></MyPATLink>
                                    </Grid>
                                  </Grid>
                                }
                                className={classes.root}
                              >
                                {
                                  _.map(courseDataList["chapter"][selectedGoal.selectedSubSubject], (chapter, j) => (
                                    !_.isUndefined(chapter.isLocal) && _.isEqual(chapter.isLocal, true) &&
                                    _.isEmpty(chapter.masterIDs) &&
                                    <ListItem
                                      key={`${chapter._id}_${j}`}

                                      className={`${selectedGoal.selectedChapter == chapter._id ? classes.activeSelected : classes.notMapped} ${classes.listItemWrapper}`}
                                      divider
                                    >
                                      <div
                                      onDragStart={(e) => this.onDragStart(e, j, chapter.parent, "chapter")}
                                      onDrop={(e) => this.onDragOver(e, j, chapter.parent, "chapter")}
                                      onDragEnd={this.onDragEnd}
                                      onDragOver={(e) => { e.preventDefault() }}
                                      draggable
                                      style={{display: "flex"}}
                                      >

                                      { showAddContent && <ListItemIcon classes={{root: "listItemIcon"}}>
               <DragIndicatorIcon />
</ListItemIcon>}
<ListItemText
                                        primaryTypographyProps={{ variant: 'body1', noWrap: true }}
                                      >
                                        <div
                                          className={showAddContent ? classes.listItemLabel : classes.listItemLabelWithoutEdit}
                                          onDoubleClick={this.handleDoubleClick.bind(this, chapter._id, '', chapter.name, 'Chapter')}

                                          onClick={this.handleSubjectSelect.bind(this, chapter._id, 'selectedChapter')}
                                        >
                                          {`${_.get(chapter, 'orderNo', '')}. ${chapter.name}`}
                                        </div>
                                        <Typography
                                          noWrap
                                          onClick={this.entityDialogEvent.bind(this, true, chapter._id, chapter.uniqueCode, chapter.orderNo)}
                                          variant="caption" className={classes.smallText}>{_.get(chapter, 'uniqueCode', '')}</Typography>
                                      </ListItemText>
                                      </div>

                                    </ListItem>
                                  )
                                  )
                                }
                                <Typography variant="body2" className={classes.unmappedInfo}>Unmapped topics will be added as new topics in the master chapter list</Typography>
                              </List>
                            }
                          </Grid>
                          <Grid container justify="center" alignItems="center" className={classes.countContentCard}>
                            <Typography align="center">{
                              chapterCount
                            } Chapter </Typography>
                          </Grid>
                        </>
                      }
                    </Paper>
                  </Grid>
                </Grid>
              </Grid>
              {/*End Chapters */}

              {/* Concepts */}
              <Grid item xs={3} className={classes.padding2x}>
                  <Grid container xs={12} justify="space-between" className={classes.mb1x}>
                    <Grid item>
                      <Typography variant="h5" align="left" className={classes.fontSize20}>Concepts</Typography>
                    </Grid>
                    <Grid item>
                      {
                        showAddContent &&
                           <AddCircleOutlineIcon onClick={this.conceptDialogEvent.bind(this, true)} color="primary" className={[classes.blueColor, classes.cursorPointer].join(' ')} />
                      }
                    </Grid>
                  </Grid>
                  {/* <Grid item xs={2}> //Future Purpose
                      {
                        showAddContent &&
                        <ACL
                          layerType={['COURSE']}
                          accessType={['ADD', 'EDIT']}
                        >
                          <Button onClick={this.conceptDialogEvent.bind(this, true)} color="primary" >Add</Button>
                        </ACL>
                      }
                    </Grid> */}
                <Grid container className={classes.gridMinHeight}>
                  <Grid item xs={12} className={classes.gridMinHeight}>
                    <Paper className={classes.paper}>
                      {
                        <>
                          <Grid className={classes.cardMinHeigth}>
                            <List>
                              {
                                _.map(courseDataList["concept"][selectedGoal.selectedChapter], (concept, i) => {
                                  conceptCount = courseDataList["concept"][selectedGoal.selectedChapter].length
                                  return !_.isEmpty(concept.masterIDs) &&
                                    <ListItem

                                      key={`${concept._id}_${i}`}
                                      divider
                                      className={`${classes.list} ${classes.conceptPadding}`}
                                    >
                                      <div
                                      draggable
                                      onDragStart={(e) => this.onDragStart(e, i, concept.parent, "concept")}
                                      onDrop={(e) => this.onDragOver(e, i, concept.parent, "concept")}
                                      onDragEnd={this.onDragEnd}
                                      onDragOver={(e) => { e.preventDefault() }}
                                      style={{display: "flex"}}
                                      >
                                      { showAddContent && <ListItemIcon classes={{root: "listItemIcon"}}>
               <DragIndicatorIcon />
</ListItemIcon>}
<ListItemText
                                        primaryTypographyProps={{ variant: 'body1', noWrap: true }}
                                      >
                                        <div
                                          className={showAddContent ? classes.listItemLabel : classes.listItemLabelWithoutEdit}
                                          onDoubleClick={this.handleDoubleClick.bind(this, concept._id, '', concept.name, 'Concept')}

                                        >
                                          {`${_.get(concept, 'orderNo', '')}. ${concept.name}`}
                                        </div>
                                        <Typography
                                          onClick={this.entityDialogEvent.bind(this, true, concept._id, concept.uniqueCode, concept.orderNo)}
                                          noWrap
                                          variant="caption" className={classes.smallText}>{_.get(concept, 'typeCode', '')}</Typography>
                                      </ListItemText>
                                      </div>
                                    </ListItem>
                                }
                                )
                              }
                            </List>
                            {
                              !_.isEmpty(_.find(courseDataList["concept"][selectedGoal.selectedChapter], function (c: any) { return c["masterIDs"].length == 0 }))
                              &&
                              <List
                                component="nav"
                                subheader={
                                  <Grid container alignContent="flex-start">
                                    <Grid item xs={10}>
                                      <Typography component="div" className={classes.umMappedHeader} variant="subtitle1" align="left">Unmapped Concepts</Typography>
                                    </Grid>
                                    <Grid className={classes.pT6} item xs={2}>
                                      <MyPATLink to={conceptLink()}><Button color="primary">Map</Button></MyPATLink>
                                    </Grid>
                                  </Grid>
                                }
                                className={classes.root}
                              >
                                {
                                  _.map(courseDataList["concept"][selectedGoal.selectedChapter], (concept, j) => (
                                    !_.isUndefined(concept.isLocal) && _.isEqual(concept.isLocal, true) &&
                                    _.isEmpty(concept.masterIDs) &&
                                    <ListItem
                                     
                                      key={`${concept._id}_${j}`}
                                      className={classes.notMapped}
                                      divider
                                    >
                                      <div
                                       draggable
                                       onDragStart={(e) => this.onDragStart(e, j, concept.parent, "concept")}
                                       onDrop={(e) => this.onDragOver(e, j, concept.parent, "concept")}
                                       onDragEnd={this.onDragEnd}
                                       onDragOver={(e) => { e.preventDefault() }}
                                       style={{display: "flex"}}
                                      >

                                     
                                      { showAddContent && <ListItemIcon classes={{root: "listItemIcon"}}>
               <DragIndicatorIcon />
</ListItemIcon>}
<ListItemText
                                        primaryTypographyProps={{ variant: 'body1', noWrap: true }}
                                      >

                                        <Typography
                                          noWrap
                                          onClick={this.entityDialogEvent.bind(this, true, concept._id, concept.uniqueCode, concept.orderNo)}
                                          variant="caption" className={classes.smallText}>{_.get(concept, 'uniqueCode', '')}</Typography>
                                        <div
                                          className={showAddContent ? classes.listItemLabel : classes.listItemLabelWithoutEdit}
                                          onDoubleClick={this.handleDoubleClick.bind(this, concept._id, '', concept.name, 'Concept')}

                                        >
                                          {`${_.get(concept, 'orderNo', '')}. ${concept.name}`}
                                        </div>
                                      </ListItemText>
                                      </div>
                                    </ListItem>

                                  )
                                  )
                                }
                                <Typography variant="body2" className={classes.unmappedInfo}>Unmapped topics will be added as new topics in the master concept list</Typography>
                              </List>
                            }
                          </Grid>
                        </>
                      }
                      <Grid container justify="center" alignItems="center" className={classes.countContentCard}>
                        <Typography align="center">{
                          conceptCount
                        } Concept </Typography>
                      </Grid>
                    </Paper>
                  </Grid>
                </Grid>
              </Grid>
              {/*End Chapters */}
            </Grid>
          </Grid>
        </Grid>


        <PublishGoalDialog
          unmap={unmap}
          handleMapToMaster={this.handleMapToMaster}
          isDialogOpen={publishContent}
          dialogCloseHandler={this.publishDialogEvent.bind(this, false)}
          selectedList={tempCourseData}
          activeCourse={activeCourse}
        />


        <SubjectAddDialogDialog
          isDialogOpen={subjectAdd}
          activeCourse={activeCourse}
          selectedList={tempCourseData}
          dialogCloseHandler={this.subjectDialogEvent.bind(this, false)}
        />
        <SubSubjectAddDialog
          isDialogOpen={subSubjectAdd}
          activeCourse={activeCourse}
          selectedList={tempCourseData}
          dialogCloseHandler={this.subSubjectDialogEvent.bind(this, false)}
          subjectDetail={selectedSubjectDetail}
          selectedGoal={selectedGoal}
        />
        <ChaptersAddDialog
          isDialogOpen={chapterAdd}
          activeCourse={activeCourse}
          selectedList={tempCourseData}
          dialogCloseHandler={this.chapterDialogEvent.bind(this, false)}
          subSubjectDetail={selectedSubSubjectDetail}
          selectedGoal={selectedGoal}
        />
        <ConceptAddDialog
          isDialogOpen={conceptAdd}
          dialogCloseHandler={this.conceptDialogEvent.bind(this, false)}
          chapterDetail={selectedChapter}
          activeCourse={activeCourse}
          selectedList={tempCourseData}
          selectedGoal={selectedGoal}
          showAddContent={showAddContent}

        />

        <MasterEntityDialog
          courseData={courseData}
          LocalEntityUpdateHandler={this.LocalEntityUpdateHandler}
          isDialogOpen={masterEntity}
          dialogCloseHandler={this.masterEntityDialogEvent.bind(this, false, '')}
          selectedEntity={selectedEntity}
          uniqueCode={this.state.currentUniqueCode}
          orderNo={this.state.orderNo}
          totalCount={this.getCountValue(_.get(selectedEntity, 'selfDetails.type', ''))}
          onSequenceNumberEdit={this.onSequenceNumberEdit}
          handleError={this.handleError.bind(this)}
          showAddContent={showAddContent}
          showError={this.state.showError}

        />


        <LocalEntityDialog
          courseData={courseData}
          isDialogOpen={localEntity}
          LocalEntityUpdateHandler={this.LocalEntityUpdateHandler}
          dialogCloseHandler={this.localEntityDialogEvent.bind(this, false, '')}
          selectedEntity={selectedEntity}
          totalCount={this.getCountValue(_.get(selectedEntity, 'selfDetails.type', ''))}
          onSequenceNumberEdit={this.onSequenceNumberEdit}
          handleError={this.handleError.bind(this)}
          showAddContent={showAddContent}
          showError={this.state.showError}
        />

        {
          !_.isEmpty(deleteDialog.toRemoveId) &&
          <SyllabusDeleteConfirm
            isDeleteDialogOpen={deleteDialog.isDeleteDialogOpen}
            topicName={deleteDialog.topicName}
            deleteLabel={'Yes Remove'}
            topicType={deleteDialog.topicType}
            removeId={deleteDialog.toRemoveId}
            onDeleteConfirmed={this.onDeleteConfirmed.bind(this)}
          />
        }

        {goalDialogOpen && (
          <AddGoalDialog
            isDialogOpen={goalDialogOpen}
            history={this.props.history}
            dialogCloseHandler={this.handleViewGoalDialogClose.bind(this)}
            dialogData={dialogData}
            actionType={actionType}
          />
        )}
      </>
    );
  }
}

const mapStateToProps = (state: any) => ({
  courseData: _.get(state, 'goalManagement.goalManagement.courseData', []),
  showAddContent: _.get(state, 'goalManagement.goalManagement.showAddContent', false),
  userData: state.loginData.userData,
  showLicenseExpiredDialog:  state.loginData.userData &&  state.loginData.userData.showLicenseExpiredDialog,
  isPostExpiryDays:  state.loginData.userData &&  state.loginData.userData.isPostExpiryDays

});


const mapDispatchToProps = (dispatch: any) => bindActionCreators({
  updateCourseData,
  getMaster,
  getCourseData,
  setShowAddContent,
  toggleLicenseExpiredDialog,
  setLoggedInUser
}, dispatch);


// @ts-ignore
export default connect(mapStateToProps, mapDispatchToProps)(withStyles(styles)(EditGoalManagementContainer));